<!-- declared up here so the cropper and zoom controls can be disabled while saving too -->
@let isSubmitting = isSubmitting$ | async;
<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>{{ sysText.changeImageDialog_title | titlecase }}</h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button
      type="button"
      class="button-reset"
      mat-dialog-close
      [aria-label]="sysText.cancel"
      [disabled]="isSubmitting">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>
<mat-dialog-content>
  <image-cropper
    [imageChangedEvent]="imageChangedEvent"
    [cropperMinWidth]="128"
    [resizeToWidth]="168"
    [resizeToHeight]="168"
    [onlyScaleDown]="true"
    [roundCropper]="true"
    [transform]="transform"
    [alignImage]="'left'"
    output="base64"
    format="png"
    [disabled]="isSubmitting"
    [cropperFrameAriaLabel]="sysText.cropArea_ariaLabel"
    (imageCropped)="imageCropped($event)"
    (cropperReady)="onCropperReady()"
    (loadImageFailed)="loadImageFailed()"
  ></image-cropper>
  @if (croppedImage) {
    <div class="zoom-container">
      <button
        mat-icon-button
        color="accent"
        [disabled]="isSubmitting"
        [attr.aria-label]="sysText.zoomOut_ariaLabel"
        (click)="zoomOut()">
        <mat-icon>zoom_out</mat-icon>
      </button>
      <mat-slider
        color="accent"
        min="0"
        max="2"
        step="0.1"
        [disabled]="isSubmitting"
        #ngSlider>
        <input
          matSliderThumb
          [(ngModel)]="scale"
          [attr.aria-label]="sysText.zoom_ariaLabel"
          (change)="zoom({source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value})"
          #ngSliderThumb="matSliderThumb"
          autocomplete="off"/>
      </mat-slider>
      <button
        mat-icon-button
        color="accent"
        [disabled]="isSubmitting"
        [attr.aria-label]="sysText.zoomIn_ariaLabel"
        (click)="zoomIn()">
        <mat-icon>zoom_in</mat-icon>
      </button>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <input hidden type="file" accept="image/*" #imgFileInput (change)="fileChangeEvent($event)" autocomplete="off"/>
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    (click)="imgFileInput.click()">
    {{ sysText.chooseImage }}
  </button>
  <span class="spacer"></span>
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      mat-dialog-close
      class="button"
      color="accent"
      [disabled]="isSubmitting">
      {{ sysText.cancel }}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks.
  it stays focusable before an image is picked too, so the guard repeats that check -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting || !croppedImage"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && croppedImage && save()">
    {{ sysText.save }}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>
